/* ============================================================
   ANARIAS CUSTOM 2.0 — Theme JavaScript (vanilla, no deps)
   ============================================================ */
(function () {
  'use strict';

  var AA = window.AA || {};
  AA.routes = AA.routes || {};
  AA.strings = AA.strings || {};

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  var scrollLockCount = 0;
  function lockScroll() { scrollLockCount++; document.body.classList.add('scroll-locked'); }
  function unlockScroll() { scrollLockCount = Math.max(0, scrollLockCount - 1); if (scrollLockCount === 0) document.body.classList.remove('scroll-locked'); }

  function trapFocus(container, e) {
    var focusable = $all('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }
  AA.toast = toast;

  /* ---------- Generic drawer controller ---------- */
  function Drawer(el, openClass) {
    this.el = el;
    this.openClass = openClass || 'is-open';
    this.isOpen = false;
    this.lastFocus = null;
    this.overlay = ensureOverlay();
    var self = this;
    this._keyHandler = function (e) {
      if (e.key === 'Escape') self.close();
      if (e.key === 'Tab' && self.isOpen) trapFocus(self.el, e);
    };
  }
  Drawer.prototype.open = function () {
    if (this.isOpen) return;
    this.isOpen = true;
    this.lastFocus = document.activeElement;
    this.el.classList.add(this.openClass);
    this.el.setAttribute('aria-hidden', 'false');
    this.overlay.classList.add('is-active');
    lockScroll();
    document.addEventListener('keydown', this._keyHandler);
    var focusTarget = this.el.querySelector('[data-drawer-focus]') || this.el.querySelector('button, a, input');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 60);
    this.overlay._activeDrawer = this;
  };
  Drawer.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.el.classList.remove(this.openClass);
    this.el.setAttribute('aria-hidden', 'true');
    if (this.overlay._activeDrawer === this) { this.overlay.classList.remove('is-active'); this.overlay._activeDrawer = null; }
    unlockScroll();
    document.removeEventListener('keydown', this._keyHandler);
    if (this.lastFocus) this.lastFocus.focus();
  };
  Drawer.prototype.toggle = function () { this.isOpen ? this.close() : this.open(); };

  var _overlay;
  function ensureOverlay() {
    if (_overlay) return _overlay;
    _overlay = document.createElement('div');
    _overlay.className = 'overlay';
    _overlay.setAttribute('data-overlay', '');
    document.body.appendChild(_overlay);
    on(_overlay, 'click', function () { if (_overlay._activeDrawer) _overlay._activeDrawer.close(); });
    return _overlay;
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var menu = $('[data-mobile-menu]');
    if (!menu) return;
    // The menu is rendered inside the header section group, whose stacking context
    // (.header-group { z-index }) traps it BELOW the body-level overlay. Reparent it
    // to <body> so it becomes a sibling of the overlay and its z-index applies at root.
    if (menu.parentElement !== document.body) {
      $all('body > [data-mobile-menu]').forEach(function (stale) { if (stale !== menu) stale.parentNode.removeChild(stale); });
      document.body.appendChild(menu);
    }
    var drawer = new Drawer(menu);
    $all('[data-mobile-menu-open]').forEach(function (btn) { on(btn, 'click', function () { drawer.open(); }); });
    $all('[data-mobile-menu-close]', menu).forEach(function (btn) { on(btn, 'click', function () { drawer.close(); }); });

    $all('[data-mobile-submenu-toggle]', menu).forEach(function (btn) {
      on(btn, 'click', function () {
        var sub = btn.parentElement.querySelector('[data-mobile-submenu]');
        if (!sub) return;
        var open = sub.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Search drawer + predictive ---------- */
  function initSearch() {
    var drawerEl = $('[data-search-drawer]');
    if (!drawerEl) return;
    var drawer = new Drawer(drawerEl);
    $all('[data-search-open]').forEach(function (btn) { on(btn, 'click', function (e) { e.preventDefault(); drawer.open(); }); });
    $all('[data-search-close]', drawerEl).forEach(function (btn) { on(btn, 'click', function () { drawer.close(); }); });

    var input = $('[data-predictive-search-input]', drawerEl);
    var results = $('[data-predictive-search-results]', drawerEl);
    if (!input || !results || !AA.routes.predictive_search) return;

    // ARIA combobox pattern
    if (!results.id) results.id = 'PredictiveResults';
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', results.id);
    results.setAttribute('role', 'listbox');

    var timer, controller, items = [], activeIndex = -1;

    function reset() {
      results.innerHTML = ''; items = []; activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      results.removeAttribute('aria-busy');
    }
    function setActive(i) {
      items.forEach(function (el) { el.classList.remove('is-active-option'); el.removeAttribute('aria-selected'); });
      activeIndex = i;
      if (i < 0 || i >= items.length) { input.removeAttribute('aria-activedescendant'); return; }
      var el = items[i];
      el.classList.add('is-active-option');
      el.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', el.id);
      el.scrollIntoView({ block: 'nearest' });
    }
    function collectItems() {
      items = $all('a', results);
      items.forEach(function (el, i) { el.setAttribute('role', 'option'); if (!el.id) el.id = 'pred-opt-' + i; });
      activeIndex = -1;
      input.setAttribute('aria-expanded', items.length ? 'true' : 'false');
    }

    on(input, 'input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { reset(); return; }
      results.setAttribute('aria-busy', 'true');
      timer = setTimeout(function () { runPredictive(q); }, 220);
    });

    on(input, 'keydown', function (e) {
      if (e.key === 'Escape') { reset(); return; }
      if (!items.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive((activeIndex + 1) % items.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive((activeIndex - 1 + items.length) % items.length); }
      else if (e.key === 'Enter' && activeIndex >= 0) { e.preventDefault(); items[activeIndex].click(); }
    });

    function runPredictive(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = AA.routes.predictive_search + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-predictive-inner]');
          results.innerHTML = inner ? inner.innerHTML : '';
          results.removeAttribute('aria-busy');
          collectItems();
        })
        .catch(function (err) { results.removeAttribute('aria-busy'); });
    }
  }

  /* ---------- Cart (drawer + page) via Sections Rendering API ---------- */
  var Cart = {
    drawerEl: null,
    drawer: null,
    init: function () {
      this.drawerEl = $('[data-cart-drawer]');
      if (this.drawerEl) {
        this.drawer = new Drawer(this.drawerEl);
        var self = this;
        $all('[data-cart-open]').forEach(function (btn) {
          on(btn, 'click', function (e) {
            if (AA.cartType === 'drawer') { e.preventDefault(); self.drawer.open(); }
          });
        });
        $all('[data-cart-close]', this.drawerEl).forEach(function (btn) { on(btn, 'click', function () { self.drawer.close(); }); });
      }
      this.bindForms();
      this.bindLineEvents(document);
    },

    bindForms: function () {
      var self = this;
      $all('[data-product-form]').forEach(function (form) {
        on(form, 'submit', function (e) {
          e.preventDefault();
          self.addFromForm(form);
        });
      });
    },

    addFromForm: function (form) {
      var self = this;
      var btn = form.querySelector('[data-add-to-cart]');
      var idInput = form.querySelector('[name="id"]');
      if (idInput && idInput.disabled) return;
      var formData = new FormData(form);
      var sections = this.sectionsToReload();
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }

      fetch(AA.routes.cart_add, {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { toast(data.description || data.message || 'Error'); return; }
          self.renderSections(data.sections);
          self.updateCount(data);
          if (AA.cartType === 'drawer' && self.drawer) self.drawer.open();
          else if (AA.cartType === 'page') window.location.href = AA.routes.cart_url;
          toast(AA.strings.added || 'Agregado');
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        })
        .catch(function () { toast('Error'); })
        .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); } });
    },

    changeQuantity: function (line, quantity) {
      var self = this;
      var sections = this.sectionsToReload();
      lockUI(true);
      fetch(AA.routes.cart_change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: sections.join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { toast(data.description || data.message || (AA.strings.unavailable || 'Error')); return; }
          self.renderSections(data.sections);
          self.updateCount(data);
          // Si Shopify recortó la cantidad al stock disponible, avisamos.
          if (quantity > 0 && data.items) {
            var li = data.items[line - 1];
            if (li && li.quantity < quantity) { toast((AA.strings.quantityCapped || 'Ajustamos la cantidad al stock disponible.')); }
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        })
        .catch(function () { toast(AA.strings.unavailable || 'Error'); })
        .finally(function () { lockUI(false); });
    },

    sectionsToReload: function () {
      var s = [];
      if ($('[data-cart-drawer]')) s.push('cart-drawer');
      if ($('[data-cart-page]')) s.push('main-cart');
      if ($('[data-cart-bubble-section]')) s.push('cart-bubble');
      if (!s.length) s.push('cart-drawer');
      return s;
    },

    renderSections: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (key) {
        var html = sections[key];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Replace contents wrappers by data attribute
        var incomingContents = doc.querySelector('[data-cart-drawer-contents]');
        var liveContents = $('[data-cart-drawer-contents]');
        if (incomingContents && liveContents) liveContents.innerHTML = incomingContents.innerHTML;

        var incomingPage = doc.querySelector('[data-cart-page-contents]');
        var livePage = $('[data-cart-page-contents]');
        if (incomingPage && livePage) livePage.innerHTML = incomingPage.innerHTML;

        var incomingBubble = doc.querySelector('[data-cart-bubble]');
        var liveBubble = $('[data-cart-bubble]');
        if (incomingBubble && liveBubble) liveBubble.outerHTML = incomingBubble.outerHTML;
      });
      Cart.bindLineEvents(document);
      AA.initAccordionsIn && AA.initAccordionsIn(document);
    },

    updateCount: function (data) {
      var count = typeof data.item_count === 'number' ? data.item_count : null;
      if (count === null) return;
      $all('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('hidden', count === 0);
      });
    },

    bindLineEvents: function (ctx) {
      var self = this;
      $all('[data-quantity-change]', ctx).forEach(function (input) {
        if (input._bound) return; input._bound = true;
        on(input, 'change', function () {
          var line = parseInt(input.getAttribute('data-line'), 10);
          var qty = Math.max(0, parseInt(input.value, 10) || 0);
          self.changeQuantity(line, qty);
        });
      });
      $all('[data-cart-remove]', ctx).forEach(function (btn) {
        if (btn._bound) return; btn._bound = true;
        on(btn, 'click', function (e) {
          e.preventDefault();
          self.changeQuantity(parseInt(btn.getAttribute('data-line'), 10), 0);
        });
      });
      // cart note
      var note = $('[data-cart-note]', ctx);
      if (note && !note._bound) {
        note._bound = true;
        var t;
        on(note, 'input', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            fetch(AA.routes.cart_update, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: note.value })
            });
          }, 500);
        });
      }
    }
  };
  function lockUI(state) {
    $all('[data-cart-drawer-contents], [data-cart-page-contents]').forEach(function (el) {
      el.style.opacity = state ? '0.5' : '';
      el.style.pointerEvents = state ? 'none' : '';
    });
  }
  AA.Cart = Cart;

  /* ---------- Quantity steppers (generic) ---------- */
  function initQuantitySteppers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-btn]');
      if (!btn) return;
      var wrap = btn.closest('.quantity');
      if (!wrap) return;
      var input = wrap.querySelector('input');
      if (!input) return;
      var step = btn.getAttribute('data-qty-btn') === 'plus' ? 1 : -1;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 0;
      var val = (parseInt(input.value, 10) || 0) + step;
      if (val < min) val = min;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Accordions (native <details>) + footer ---------- */
  function initFooterAccordions() {
    $all('[data-footer-col]').forEach(function (col) {
      var title = col.querySelector('[data-footer-col-toggle]');
      if (!title) return;
      on(title, 'click', function () {
        if (window.matchMedia('(max-width: 749px)').matches) col.classList.toggle('is-open');
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initProductGallery() {
    $all('[data-product-gallery]').forEach(function (gallery) {
      var slides = $('[data-gallery-slides]', gallery);
      var thumbs = $all('[data-gallery-thumb]', gallery);
      var dots = $all('[data-gallery-dot]', gallery);
      var slideEls = $all('[data-gallery-slide]', gallery);
      if (!slides) return;

      var current = 0;
      function goTo(index) {
        if (!slideEls.length) return;
        index = (index + slideEls.length) % slideEls.length;
        var target = slideEls[index];
        if (!target) return;
        current = index;
        slideEls.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        slides.scrollTo({ left: target.offsetLeft - slides.offsetLeft, top: 0, behavior: 'smooth' });
        setActive(index);
      }
      function setActive(index) {
        current = index;
        thumbs.forEach(function (t, i) { var a = i === index; t.setAttribute('aria-current', a ? 'true' : 'false'); t.classList.toggle('is-active', a); });
        dots.forEach(function (d, i) { var a = i === index; d.setAttribute('aria-current', a ? 'true' : 'false'); d.classList.toggle('is-active', a); });
      }
      thumbs.forEach(function (thumb, i) { on(thumb, 'click', function () { goTo(i); }); });
      dots.forEach(function (dot, i) { on(dot, 'click', function () { goTo(i); }); });
      var prevBtn = $('[data-gallery-prev]', gallery);
      var nextBtn = $('[data-gallery-next]', gallery);
      if (prevBtn) on(prevBtn, 'click', function () { goTo(current - 1); });
      if (nextBtn) on(nextBtn, 'click', function () { goTo(current + 1); });
      on(gallery, 'keydown', function (e) {
        if (e.key === 'ArrowLeft') { goTo(current - 1); }
        else if (e.key === 'ArrowRight') { goTo(current + 1); }
      });
      // Asegura una imagen activa al cargar (desktop muestra solo la activa)
      if (slideEls.length && !slides.querySelector('.is-active')) { slideEls[0].classList.add('is-active'); setActive(0); }

      // sync active on scroll (mobile)
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var idx = slideEls.indexOf(entry.target);
            if (idx > -1) setActive(idx);
          }
        });
      }, { root: slides, threshold: 0.6 });
      slideEls.forEach(function (s) { io.observe(s); });

      gallery._goToMedia = function (mediaId) {
        var idx = slideEls.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
        if (idx > -1) goTo(idx);
      };

      // Lightbox zoom (con navegación entre todas las imágenes)
      var zoomImgs = $all('[data-zoom]', gallery);
      var zoomList = zoomImgs.map(function (zi) { return { src: zi.getAttribute('data-zoom-src') || zi.src, alt: zi.alt || '' }; });
      zoomImgs.forEach(function (zi, zidx) {
        on(zi, 'click', function () { openLightbox(zoomList, zidx); });
      });
    });
  }

  /* ---------- Product description tabs ---------- */
  function initProductTabs() {
    $all('[data-product-tabs]').forEach(function (tabs) {
      var btns = $all('[data-tab]', tabs);
      var panels = $all('[data-tab-panel]', tabs);
      btns.forEach(function (btn) {
        on(btn, 'click', function () {
          var id = btn.getAttribute('data-tab');
          btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === id); });
        });
      });
    });
  }

  function openLightbox(list, startIndex) {
    if (!Array.isArray(list)) { list = [{ src: list, alt: startIndex || '' }]; startIndex = 0; }
    if (!list.length) return;
    var idx = startIndex || 0;
    var multi = list.length > 1;
    var lb = document.createElement('div');
    lb.className = 'aa-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<button type="button" class="aa-lightbox__close" aria-label="Cerrar">&times;</button>' +
      (multi ? '<button type="button" class="aa-lightbox__nav aa-lightbox__nav--prev" aria-label="Imagen anterior">‹</button>' : '') +
      '<img class="aa-lightbox__img" alt="">' +
      (multi ? '<button type="button" class="aa-lightbox__nav aa-lightbox__nav--next" aria-label="Imagen siguiente">›</button>' : '') +
      (multi ? '<div class="aa-lightbox__counter"></div>' : '');
    var imgEl = lb.querySelector('.aa-lightbox__img');
    var counterEl = lb.querySelector('.aa-lightbox__counter');
    function render() {
      imgEl.src = list[idx].src;
      imgEl.alt = list[idx].alt;
      if (counterEl) counterEl.textContent = (idx + 1) + ' / ' + list.length;
    }
    function go(d) { idx = (idx + d + list.length) % list.length; render(); }
    function close() { lb.remove(); unlockScroll(); document.removeEventListener('keydown', onKey); }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (multi && e.key === 'ArrowLeft') go(-1);
      else if (multi && e.key === 'ArrowRight') go(1);
    }
    on(lb, 'click', function (e) {
      var t = e.target;
      if (t.classList.contains('aa-lightbox__nav--prev')) { go(-1); return; }
      if (t.classList.contains('aa-lightbox__nav--next')) { go(1); return; }
      if (t === lb || t.classList.contains('aa-lightbox__close')) close();
    });
    // Swipe en móvil
    var x0 = null;
    on(lb, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    on(lb, 'touchend', function (e) {
      if (x0 === null || !multi) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });
    render();
    document.addEventListener('keydown', onKey);
    document.body.appendChild(lb);
    lockScroll();
  }

  /* ---------- Variant picker ---------- */
  function initVariantPickers() {
    $all('[data-product-form]').forEach(function (form) {
      var section = form.closest('[data-product-section]') || document;
      var dataEl = section.querySelector('[data-product-json]') || document.querySelector('[data-product-json]');
      if (!dataEl) return;
      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var variants = product.variants || [];
      var idInput = form.querySelector('[name="id"]');
      var pickers = $all('[data-variant-input]', form);
      if (!pickers.length || !idInput) return;

      function getSelectedOptions() {
        var opts = [];
        var groups = {};
        pickers.forEach(function (input) {
          if (input.type === 'radio' && !input.checked) return;
          var pos = parseInt(input.getAttribute('data-option-position'), 10);
          groups[pos] = input.value;
        });
        Object.keys(groups).sort().forEach(function (k) { opts.push(groups[k]); });
        return opts;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function update() {
        var opts = getSelectedOptions();
        var variant = findVariant(opts);
        // update "current value" labels
        $all('[data-option-current]', form).forEach(function (el) {
          var pos = el.getAttribute('data-option-current');
          el.textContent = opts[parseInt(pos, 10) - 1] || '';
        });
        var btn = form.querySelector('[data-add-to-cart]');
        var btnText = btn ? btn.querySelector('.btn-text') : null;
        var priceEl = section.querySelector('[data-price-container]');

        if (!variant) {
          idInput.value = '';
          if (btn) { btn.setAttribute('disabled', 'disabled'); }
          if (btnText) btnText.textContent = AA.strings.unavailable || 'No disponible';
          return;
        }
        idInput.value = variant.id;
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
        // price
        if (priceEl && variant.priceHtmlByVariant) { /* optional */ }
        updatePriceDisplay(section, variant, product);
        // availability
        if (btn) {
          if (variant.available) {
            btn.removeAttribute('disabled');
            if (btnText) btnText.textContent = (product.preorder ? (AA.strings.preorder || AA.strings.addToCart) : AA.strings.addToCart);
          } else {
            btn.setAttribute('disabled', 'disabled');
            if (btnText) btnText.textContent = AA.strings.soldOut || 'Agotado';
          }
        }
        // gallery jump
        if (variant.featured_media && variant.featured_media.id) {
          var gallery = section.querySelector('[data-product-gallery]');
          if (gallery && gallery._goToMedia) gallery._goToMedia(variant.featured_media.id);
        }
        // disable unavailable size options visually
        refreshAvailability();
      }

      function refreshAvailability() {
        var opts = getSelectedOptions();
        pickers.forEach(function (input) {
          var pos = parseInt(input.getAttribute('data-option-position'), 10);
          var testOpts = opts.slice();
          testOpts[pos - 1] = input.value;
          var match = variants.find(function (v) {
            return v.options.every(function (o, i) { return i === (pos - 1) ? o === input.value : o === testOpts[i]; });
          });
          var wrap = input.closest('.variant-value');
          if (wrap) wrap.classList.toggle('is-unavailable', !match || !match.available);
        });
      }

      pickers.forEach(function (input) { on(input, 'change', update); });
      update();
    });
  }

  function updatePriceDisplay(section, variant, product) {
    var container = section.querySelector('[data-price-container]');
    if (!container) return;
    var saleEl = container.querySelector('[data-price-sale]');
    var compareEl = container.querySelector('[data-price-compare]');
    var regularEl = container.querySelector('[data-price-regular]');
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    container.classList.toggle('price--on-sale', !!onSale);
    if (regularEl) regularEl.innerHTML = formatMoney(variant.price);
    if (saleEl) saleEl.innerHTML = formatMoney(variant.price);
    if (compareEl) compareEl.innerHTML = onSale ? formatMoney(variant.compare_at_price) : '';
  }

  function formatMoney(cents) {
    var fmt = AA.moneyFormat || '${{amount}}';
    var value = (cents / 100);
    // Colombian style: no decimals, thousands with dot
    function withDelimiters(num) {
      var s = Math.round(num).toString();
      return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      if (name.indexOf('amount') === 0) {
        if (name === 'amount_no_decimals' || name === 'amount_no_decimals_with_comma_separator' || name === 'amount_no_decimals_with_space_separator') return withDelimiters(value);
        return withDelimiters(value);
      }
      return '';
    });
  }
  AA.formatMoney = formatMoney;

  /* ---------- Sticky add bar ---------- */
  function initStickyBar() {
    var bar = $('[data-sticky-bar]');
    var anchor = $('[data-sticky-anchor]');
    if (!bar || !anchor) return;
    document.body.classList.add('has-sticky-bar');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);
    var stickyBtn = bar.querySelector('[data-sticky-add]');
    if (stickyBtn) on(stickyBtn, 'click', function () {
      var form = $('[data-product-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.querySelector('[data-add-to-cart]').click();
    });
  }

  /* ---------- Facets (mobile drawer + auto-submit) ---------- */
  function initFacets() {
    var drawerEl = $('[data-facets-drawer]');
    if (drawerEl) {
      var drawer = new Drawer(drawerEl);
      // En móvil el drawer se renderiza dentro de .main-content (contexto z-index:0) que lo
      // atrapa DEBAJO del overlay (a nivel body). Lo movemos a <body> mientras está abierto
      // para que su z-index gane, y lo regresamos al cerrar (en desktop hace de sidebar fijo).
      var fAnchor = document.createComment('facets-drawer-anchor');
      var fMoved = false;
      var fOpen = drawer.open.bind(drawer);
      var fClose = drawer.close.bind(drawer);
      drawer.open = function () {
        if (!fMoved && drawerEl.parentNode) {
          drawerEl.parentNode.insertBefore(fAnchor, drawerEl);
          document.body.appendChild(drawerEl);
          fMoved = true;
        }
        fOpen();
      };
      drawer.close = function () {
        fClose();
        if (fMoved && fAnchor.parentNode) {
          setTimeout(function () {
            if (fMoved) { fAnchor.parentNode.insertBefore(drawerEl, fAnchor); fAnchor.parentNode.removeChild(fAnchor); fMoved = false; }
          }, 380);
        }
      };
      $all('[data-facets-open]').forEach(function (b) { on(b, 'click', function () { drawer.open(); }); });
      $all('[data-facets-close]', drawerEl).forEach(function (b) { on(b, 'click', function () { drawer.close(); }); });
    }
    // Desktop: dropdowns de filtros — cierran al hacer click afuera, Escape, y uno a la vez
    on(document, 'click', function (e) {
      if (window.innerWidth < 990) return;
      $all('.facets-drawer .facet[open]').forEach(function (f) { if (!f.contains(e.target)) f.removeAttribute('open'); });
    });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') $all('.facets-drawer .facet[open]').forEach(function (f) { f.removeAttribute('open'); });
    });
    $all('.facets-drawer .facet > summary').forEach(function (s) {
      on(s, 'click', function () {
        if (window.innerWidth < 990) return;
        var facet = s.parentElement;
        setTimeout(function () {
          if (facet.open) { $all('.facets-drawer .facet[open]').forEach(function (f) { if (f !== facet) f.removeAttribute('open'); }); }
        }, 0);
      });
    });
    // Custom sort dropdown (reemplaza el <select> nativo)
    $all('[data-sort-dd]').forEach(function (dd) {
      var toggle = $('[data-sort-toggle]', dd);
      var menu = $('[data-sort-menu]', dd);
      if (!toggle || !menu) return;
      function close() { menu.setAttribute('hidden', ''); toggle.setAttribute('aria-expanded', 'false'); }
      on(toggle, 'click', function (e) {
        e.stopPropagation();
        if (menu.hasAttribute('hidden')) { menu.removeAttribute('hidden'); toggle.setAttribute('aria-expanded', 'true'); }
        else { close(); }
      });
      $all('[data-sort-value]', menu).forEach(function (opt) {
        on(opt, 'click', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', opt.getAttribute('data-sort-value'));
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });
      on(document, 'click', function (e) { if (!dd.contains(e.target)) close(); });
      on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });
    });
    // facet form auto-submit on change (desktop); mobile uses Apply button which closes drawer then change already fired
    $all('[data-facet-form]').forEach(function (form) {
      on(form, 'change', function (e) {
        if (e.target && (e.target.type === 'checkbox' || e.target.tagName === 'SELECT')) {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });
      // price inputs submit on Enter / blur
      $all('input[type="number"]', form).forEach(function (inp) {
        on(inp, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.submit(); } });
      });
    });
  }

  /* ---------- Announcement bar rotation ---------- */
  function initAnnouncement() {
    $all('[data-announcement-rotate]').forEach(function (track) {
      var items = $all('[data-announcement-item]', track);
      if (items.length < 2) return;
      var i = 0;
      items.forEach(function (it, idx) { it.style.display = idx === 0 ? '' : 'none'; });
      setInterval(function () {
        items[i].style.display = 'none';
        i = (i + 1) % items.length;
        items[i].style.display = '';
      }, 5000);
    });
  }

  /* ---------- Newsletter popup ---------- */
  function initNewsletterPopup() {
    var popup = $('[data-nl-popup]');
    if (!popup) return;
    var KEY = 'aa_nl_popup';
    var form = popup.querySelector('.nl-popup__form');
    var teaser = document.querySelector('[data-nl-teaser]');
    var justSubscribed = !!popup.querySelector('[data-nl-subscribed]');
    var designMode = window.Shopify && Shopify.designMode;

    function isSubscribed() { try { return localStorage.getItem(KEY) === 'subscribed'; } catch (e) { return false; } }
    function showTeaser() { if (teaser && !isSubscribed()) teaser.classList.add('is-shown'); }
    function hideTeaser() { if (teaser) teaser.classList.remove('is-shown'); }

    function open() {
      if (popup.classList.contains('is-open')) return;
      hideTeaser();
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('nl-locked');
      requestAnimationFrame(function () { popup.classList.add('is-visible'); });
      var closeBtn = popup.querySelector('.nl-popup__close');
      if (closeBtn) { try { closeBtn.focus(); } catch (e) {} }
    }
    function close(remember) {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('nl-locked');
      setTimeout(function () { popup.classList.remove('is-open'); }, 400);
      if (remember !== false && !isSubscribed()) { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
      showTeaser();
    }

    $all('[data-nl-close]', popup).forEach(function (el) { on(el, 'click', function () { close(true); }); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && popup.classList.contains('is-open')) close(true); });
    if (teaser) { on(teaser, 'click', function () { open(); }); }

    var copyBtn = popup.querySelector('[data-nl-copy]');
    if (copyBtn) {
      on(copyBtn, 'click', function () {
        var codeEl = popup.querySelector('[data-nl-code]');
        var code = codeEl ? codeEl.getAttribute('data-nl-code') : '';
        if (!code) return;
        var lbl = copyBtn.querySelector('[data-nl-copy-label]');
        var done = function () { if (lbl) { var old = lbl.textContent; lbl.textContent = '¡Copiado!'; setTimeout(function () { lbl.textContent = old; }, 1800); } };
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done).catch(done); } else { done(); }
      });
    }

    if (form) {
      on(form, 'submit', function () {
        var pad = function (v) { return v && v.length === 1 ? '0' + v : (v || ''); };
        var nameEl = form.querySelector('[data-nl-name]');
        var name = nameEl ? nameEl.value.trim() : '';
        var d = form.querySelector('[data-nl-bday="d"]'), m = form.querySelector('[data-nl-bday="m"]'), y = form.querySelector('[data-nl-bday="y"]');
        var dv = d && d.value ? d.value.trim() : '', mv = m && m.value ? m.value.trim() : '', yv = y && y.value ? y.value.trim() : '';
        var hasBday = !!(dv || mv || yv);
        var bdayText = hasBday ? (dv || '--') + '/' + (mv || '--') + (yv ? '/' + yv : '') : '';
        // Nota (nombre + cumpleaños) — visible en la ficha del cliente (clientes nuevos)
        var note = form.querySelector('[data-nl-note]');
        if (note) {
          var parts = [];
          if (name) parts.push('Nombre: ' + name);
          if (bdayText) parts.push('Cumpleaños: ' + bdayText);
          note.value = parts.join(' · ');
        }
        // Cumpleaños como ETIQUETA en formato ISO (AAAA-MM-DD): lo lee Shopify Flow para llenar el metacampo facts.birth_date
        var tagsEl = form.querySelector('input[name="contact[tags]"]');
        if (tagsEl && dv && mv && yv) {
          tagsEl.value = tagsEl.value + ', cumple:' + yv + '-' + pad(mv) + '-' + pad(dv);
        }
      });
    }

    if (justSubscribed) { open(); try { localStorage.setItem(KEY, 'subscribed'); } catch (e) {} return; }
    if (designMode) { open(); return; }

    if (/\/(cart|account|challenge|password)/.test(location.pathname)) return;
    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch (e) {}
    if (stored === 'subscribed') return;
    var freqDays = parseInt(popup.getAttribute('data-frequency'), 10) || 0;
    if (stored && freqDays > 0 && (Date.now() - parseInt(stored, 10)) / 86400000 < freqDays) { showTeaser(); return; }
    var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 0) * 1000;
    // Abrir DESPUÉS de window.load (y en idle) para no afectar el LCP / rendimiento de la carga inicial
    var fire = function () { setTimeout(function () { if (window.requestIdleCallback) { requestIdleCallback(open, { timeout: 2000 }); } else { open(); } }, delay); };
    if (document.readyState === 'complete') { fire(); } else { window.addEventListener('load', fire, { once: true }); }
  }

  /* ---------- Header scroll state (shrink + cream bg, transparent re-pin) ---------- */
  function initHeaderScroll() {
    var header = $('[data-header]');
    if (!header) return;
    var root = document.documentElement;
    function setBottom() { root.style.setProperty('--header-bottom', Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 'px'); }
    setBottom();
    window.addEventListener('resize', setBottom, { passive: true });
    window.addEventListener('scroll', setBottom, { passive: true });
    if ('IntersectionObserver' in window) {
      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:48px;pointer-events:none;';
      document.body.insertBefore(sentinel, document.body.firstChild);
      var io = new IntersectionObserver(function (entries) {
        header.classList.toggle('is-scrolled', !entries[0].isIntersecting);
        setBottom();
      }, { threshold: 0 });
      io.observe(sentinel);
    } else {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); setBottom(); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) { $all('.reveal').forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $all('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Quick add ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) { window.location.href = btn.getAttribute('data-product-url'); return; }
      btn.classList.add('is-loading');
      var sections = Cart.sectionsToReload();
      fetch(AA.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({ id: variantId, quantity: 1, sections: sections.join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { toast(data.description || 'Error'); return; }
          Cart.renderSections(data.sections);
          Cart.updateCount(data);
          if (AA.cartType === 'drawer' && Cart.drawer) Cart.drawer.open();
          toast(AA.strings.added || 'Agregado');
        })
        .catch(function () { toast('Error'); })
        .finally(function () { btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- Shop the look (set / combo) ---------- */
  function initShopTheLook() {
    var root = $('[data-shop-the-look]');
    if (!root) return;
    var items = $all('[data-stl-item]', root);
    var totalEl = $('[data-stl-total]', root);
    var addBtn = $('[data-stl-add]', root);
    function recalc() {
      var total = 0, n = 0;
      items.forEach(function (it) {
        var c = $('[data-stl-check]', it);
        var on_ = c && c.checked;
        it.classList.toggle('is-checked', !!on_);
        if (on_) { total += parseInt(it.getAttribute('data-price'), 10) || 0; n++; }
      });
      if (totalEl) totalEl.innerHTML = AA.formatMoney(total);
      if (addBtn) addBtn.disabled = n === 0;
    }
    items.forEach(function (it) { var c = $('[data-stl-check]', it); if (c) on(c, 'change', recalc); });
    recalc();
    if (addBtn) on(addBtn, 'click', function () {
      var payload = [];
      items.forEach(function (it) { var c = $('[data-stl-check]', it); if (c && c.checked) payload.push({ id: parseInt(it.getAttribute('data-variant-id'), 10), quantity: 1 }); });
      if (!payload.length) return;
      addBtn.classList.add('is-loading');
      var sections = Cart.sectionsToReload();
      fetch(AA.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({ items: payload, sections: sections.join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { toast(data.description || 'Error'); return; }
          Cart.renderSections(data.sections);
          Cart.updateCount(data);
          if (AA.cartType === 'drawer' && Cart.drawer) Cart.drawer.open();
          toast(AA.strings.added || 'Agregado');
        })
        .catch(function () { toast('Error'); })
        .finally(function () { addBtn.classList.remove('is-loading'); });
    });
  }

  /* ---------- Product recommendations (lazy) ---------- */
  function initRecommendations() {
    $all('[data-product-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          obs.unobserve(el);
          fetch(url)
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var incoming = doc.querySelector('[data-product-recommendations] .page-width');
              var live = el.querySelector('.page-width');
              if (incoming && live && incoming.innerHTML.trim()) {
                live.innerHTML = incoming.innerHTML;
                initReveal();
                initCarousels();
              }
            })
            .catch(function () {});
        });
      }, { rootMargin: '300px' });
      io.observe(el);
    });
  }

  /* ---------- Size guide modal ---------- */
  function initSizeGuide() {
    var modal = $('[data-size-guide-modal]');
    if (!modal) return;
    function open() { modal.classList.add('is-open'); lockScroll(); }
    function close() { modal.classList.remove('is-open'); unlockScroll(); }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-guide-open]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-size-guide-close]')) { close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Card quickshop (reveal sizes on the image) ---------- */
  function initCardShop() {
    if (initCardShop._bound) return; initCardShop._bound = true;
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-card-shop-open]');
      if (!trigger) return;
      e.preventDefault();
      var shop = trigger.closest('[data-card-shop]');
      if (!shop) return;
      var sizes = shop.querySelector('[data-card-sizes]');
      if (!sizes) return;
      var willOpen = sizes.hasAttribute('hidden');
      $all('[data-card-sizes]').forEach(function (s) {
        if (s !== sizes) {
          s.setAttribute('hidden', '');
          var t = s.parentElement.querySelector('[data-card-shop-open]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
      if (willOpen) { sizes.removeAttribute('hidden'); trigger.setAttribute('aria-expanded', 'true'); }
      else { sizes.setAttribute('hidden', ''); trigger.setAttribute('aria-expanded', 'false'); }
    });
  }

  /* ---------- Wishlist heart (toggle; connect a wishlist app to [data-wishlist]) ---------- */
  function initWishlist() {
    if (initWishlist._bound) return; initWishlist._bound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist]');
      if (!btn) return;
      var active = btn.classList.toggle('is-active');
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      document.dispatchEvent(new CustomEvent('wishlist:toggle', { detail: { active: active, button: btn } }));
    });
  }

  /* ---------- Card color swatches → swap image + select variant ---------- */
  function initCardSwatches() {
    if (initCardSwatches._bound) return; initCardSwatches._bound = true;
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-card-swatch]');
      if (!sw) return;
      e.preventDefault();
      var card = sw.closest('.product-card');
      if (!card) return;
      var src = sw.getAttribute('data-variant-image');
      var img = card.querySelector('.product-card__img--primary');
      if (img && src) { img.removeAttribute('srcset'); img.src = src; card.classList.add('is-color-selected'); }
      var siblings = sw.parentElement.querySelectorAll('[data-card-swatch]');
      Array.prototype.forEach.call(siblings, function (s) { s.classList.toggle('is-active', s === sw); });
      var vid = sw.getAttribute('data-variant-id');
      if (vid) {
        var addBtn = card.querySelector('[data-quick-add][data-variant-id]');
        if (addBtn) addBtn.setAttribute('data-variant-id', vid);
      }
    });
  }

  /* ---------- Share buttons ---------- */
  function initShare() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-share-copy]');
      if (!btn) return;
      e.preventDefault();
      var url = btn.getAttribute('data-share-url') || window.location.href;
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { toast(AA.strings.linkCopied || 'Enlace copiado'); });
    });
  }

  /* ---------- Hero slider ---------- */
  function reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function initHeroSliders() {
    $all('[data-hero-slider]').forEach(function (slider) {
      if (slider._init) return; slider._init = true;
      var slides = $all('[data-slide]', slider);
      if (slides.length < 1) return;
      var dots = $all('[data-hero-dot]', slider);
      var autoplay = slider.hasAttribute('data-autoplay');
      var speed = parseInt(slider.getAttribute('data-speed'), 10) || 6000;
      var idx = 0, timer = null;

      function go(n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      }
      function next() { go(idx + 1); }
      function prev() { go(idx - 1); }
      function start() { stop(); if (autoplay && slides.length > 1 && !reducedMotion()) timer = setInterval(next, speed); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      $all('[data-hero-next]', slider).forEach(function (b) { on(b, 'click', function () { next(); start(); }); });
      $all('[data-hero-prev]', slider).forEach(function (b) { on(b, 'click', function () { prev(); start(); }); });
      dots.forEach(function (d, i) { on(d, 'click', function () { go(i); start(); }); });

      var x0 = null;
      on(slider, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      on(slider, 'touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); start(); }
        x0 = null;
      });
      on(slider, 'mouseenter', stop);
      on(slider, 'mouseleave', start);
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

      go(0);
      start();
    });
  }

  /* ---------- Header solid when mega menu opens ---------- */
  function initMegaHeader() {
    var header = $('[data-header]');
    if (!header) return;
    $all('.main-nav__item').forEach(function (item) {
      if (!item.querySelector('.mega-menu')) return;
      on(item, 'mouseenter', function () {
        header.classList.add('is-mega-open');
        document.documentElement.style.setProperty('--header-bottom', Math.round(header.getBoundingClientRect().bottom) + 'px');
      });
      on(item, 'mouseleave', function () { header.classList.remove('is-mega-open'); });
    });
  }

  /* ---------- Category tabs ---------- */
  function initCategoryTabs() {
    $all('.cat-tabs').forEach(function (wrap) {
      if (wrap._init) return; wrap._init = true;
      var tabs = $all('[data-cat-tab]', wrap);
      var panels = $all('[data-cat-panel]', wrap);
      var viewalls = $all('[data-cat-viewall]', wrap);
      tabs.forEach(function (tab) {
        on(tab, 'click', function () {
          var i = tab.getAttribute('data-cat-tab');
          tabs.forEach(function (t) { var a = t === tab; t.classList.toggle('is-active', a); t.setAttribute('aria-selected', a ? 'true' : 'false'); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-cat-panel') === i); });
          var url = tab.getAttribute('data-url'); if (url && url !== '#') viewalls.forEach(function (v) { v.setAttribute('href', url); });
          var active = wrap.querySelector('[data-cat-panel].is-active [data-carousel]');
          if (active && active._updateArrows) active._updateArrows();
        });
      });
    });
  }

  /* ---------- Horizontal carousels (arrows) ---------- */
  function initCarousels() {
    $all('[data-carousel]').forEach(function (car) {
      if (car._init) return; car._init = true;
      var track = $('[data-carousel-track]', car);
      if (!track) return;
      var prev = $('[data-carousel-prev]', car);
      var next = $('[data-carousel-next]', car);
      function update() {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      car._updateArrows = update;
      var amount = function () { return track.clientWidth * 0.85; };
      if (prev) on(prev, 'click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      if (next) on(next, 'click', function () { track.scrollBy({ left: amount(), behavior: 'smooth' }); });
      on(track, 'scroll', update, { passive: true });
      update();
    });
  }

  /* ---------- Boutiques filters (vanilla, accesible) ---------- */
  function initBoutiqueFilters() {
    var wrap = $('[data-boutique-filters]');
    if (!wrap) return;
    var filters = $all('[data-filter]', wrap);
    var cards = $all('[data-boutique]');
    var groups = $all('.boutiques-group');
    var noResults = $('[data-no-results]');
    function apply(filter) {
      var parts = filter.split(':');
      var kind = parts[0], val = parts[1] || '';
      var visible = 0;
      cards.forEach(function (card) {
        var show = filter === 'all'
          || (kind === 'country' && card.getAttribute('data-country') === val)
          || (kind === 'city' && card.getAttribute('data-city') === val);
        card.hidden = !show;
        if (show) visible++;
      });
      groups.forEach(function (g) {
        var any = false;
        $all('[data-boutique]', g).forEach(function (c) { if (!c.hidden) any = true; });
        g.hidden = !any;
      });
      if (noResults) noResults.hidden = visible !== 0;
    }
    filters.forEach(function (btn) {
      on(btn, 'click', function () {
        filters.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        apply(btn.getAttribute('data-filter'));
      });
    });
    // Aplica el filtro activo al cargar (ej. Colombia por defecto, ya no hay "Todos")
    var activeBtn = wrap.querySelector('.boutique-filter.is-active') || filters[0];
    if (activeBtn) apply(activeBtn.getAttribute('data-filter'));
  }

  /* ---------- Init ---------- */
  function init() {
    initHeroSliders();
    initCategoryTabs();
    initCarousels();
    initMobileMenu();
    initSearch();
    Cart.init();
    initQuantitySteppers();
    initFooterAccordions();
    initProductGallery();
    initProductTabs();
    initVariantPickers();
    initStickyBar();
    initFacets();
    initAnnouncement();
    initNewsletterPopup();
    initHeaderScroll();
    initMegaHeader();
    initReveal();
    initQuickAdd();
    initShare();
    initSizeGuide();
    initRecommendations();
    initShopTheLook();
    initCardShop();
    initCardSwatches();
    initWishlist();
    initBoutiqueFilters();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-init dynamic content on Shopify theme editor events
  document.addEventListener('shopify:section:load', function (e) {
    var slider = e.target.querySelector ? e.target.querySelector('[data-hero-slider]') : null;
    if (slider) slider._init = false;
    initHeroSliders(); initCategoryTabs(); initCarousels(); initProductGallery(); initVariantPickers(); initFacets(); initReveal(); Cart.init();
  });

  window.AA = AA;
})();
